// This file is auto-generated by @hey-api/openapi-ts

import { type Options, getAuth, browseStructure, getCategory, chat, models, listAssignedChecklists, listChecklistTemplates, getConfiguration, getAllCourses, addCourse, assignUsersToChecklist1, listEnrollmentsByCourse, getComplianceCourses, generateCourseReport, getOperatorCourseSettings, setOperatorCourseSetting, getSqssl, synchronizeUser, learnUponWebhook, deleteCourse, updateCourse, getCourseById, updateUserComplianceCourseDuration, saveDocuments, setAuthCookie, deleteDocument, getDocument, getCategoryIcons, getProcedureIcons, getPlansSummary, getPlanReport, getUsersSummaryReport, getUserSummaryReport, getManagedPlans, createPlan, getActivePlanAssignments, getSystemPlans1, getSystemPlans, deletePlan, getPlanAndAssignments, updatePlan, unassignUsers, assignUsers, patchAutoAssign, clonePlan, cloneAsSystemPlan, updateDueDate, markPlanAsComplete, upsertReadonlySubscription, resetPlanSteps, heartbeat, updateStepStatus, heartbeatTrainTogether, trainTogetherUpdateStepStatus, trainTogetherMarkPlanAsComplete, getCustomQuizzes, createCustomQuiz, updateCustomQuiz, deleteCustomQuiz, getCustomQuizDetails, getUserTrainingPlans, listPlanStatus, getResource, search, searchClickFeedback, getTranslations, getUsersForLocations, getUsers, getOperators, getUserPreferences, saveUserPreferences, getUserPlanAssignmentSummaries, updateChecklist, listAllChecklists, listAssignableChecklists, listAssignedByChecklist, listEditableChecklists, resetChecklist, getTemplates, createPlanFromTemplate, deleteChecklist, getChecklist, duplicateChecklist, unassignUsersToChecklist, assignUsersToChecklist, setDueDateOnChecklist, updateChecklistStatus, stepHeartBeat, updateStepStatus1, webhookQuiz } from '../sdk.gen';
import { queryOptions, type UseMutationOptions } from '@tanstack/react-query';
import type { GetAuthData, BrowseStructureData, GetCategoryData, ChatData, ChatError, ChatResponse, ModelsData, ListAssignedChecklistsData, ListChecklistTemplatesData, GetConfigurationData, GetAllCoursesData, AddCourseData, AddCourseError, AddCourseResponse, AssignUsersToChecklist1Data, AssignUsersToChecklist1Error, ListEnrollmentsByCourseData, GetComplianceCoursesData, GenerateCourseReportData, GetOperatorCourseSettingsData, SetOperatorCourseSettingData, SetOperatorCourseSettingError, GetSqsslData, SynchronizeUserData, SynchronizeUserError, LearnUponWebhookData, LearnUponWebhookError, LearnUponWebhookResponse, DeleteCourseData, DeleteCourseError, UpdateCourseData, UpdateCourseError, UpdateCourseResponse, GetCourseByIdData, UpdateUserComplianceCourseDurationData, UpdateUserComplianceCourseDurationError, SaveDocumentsData, SaveDocumentsError, SetAuthCookieData, DeleteDocumentData, DeleteDocumentError, DeleteDocumentResponse, GetDocumentData, GetCategoryIconsData, GetProcedureIconsData, GetPlansSummaryData, GetPlanReportData, GetUsersSummaryReportData, GetUserSummaryReportData, GetManagedPlansData, CreatePlanData, CreatePlanError, CreatePlanResponse, GetActivePlanAssignmentsData, GetSystemPlans1Data, GetSystemPlansData, DeletePlanData, DeletePlanError, DeletePlanResponse, GetPlanAndAssignmentsData, UpdatePlanData, UpdatePlanError, UpdatePlanResponse, UnassignUsersData, UnassignUsersError, UnassignUsersResponse, AssignUsersData, AssignUsersError, PatchAutoAssignData, PatchAutoAssignError, PatchAutoAssignResponse, ClonePlanData, ClonePlanError, ClonePlanResponse, CloneAsSystemPlanData, CloneAsSystemPlanError, CloneAsSystemPlanResponse, UpdateDueDateData, UpdateDueDateError, UpdateDueDateResponse, MarkPlanAsCompleteData, MarkPlanAsCompleteError, MarkPlanAsCompleteResponse, UpsertReadonlySubscriptionData, UpsertReadonlySubscriptionError, UpsertReadonlySubscriptionResponse, ResetPlanStepsData, ResetPlanStepsError, ResetPlanStepsResponse, HeartbeatData, HeartbeatError, HeartbeatResponse, UpdateStepStatusData, UpdateStepStatusError, UpdateStepStatusResponse, HeartbeatTrainTogetherData, HeartbeatTrainTogetherError, HeartbeatTrainTogetherResponse, TrainTogetherUpdateStepStatusData, TrainTogetherUpdateStepStatusError, TrainTogetherUpdateStepStatusResponse, TrainTogetherMarkPlanAsCompleteData, TrainTogetherMarkPlanAsCompleteError, TrainTogetherMarkPlanAsCompleteResponse, GetCustomQuizzesData, CreateCustomQuizData, CreateCustomQuizError, CreateCustomQuizResponse, UpdateCustomQuizData, UpdateCustomQuizError, UpdateCustomQuizResponse, DeleteCustomQuizData, DeleteCustomQuizError, GetCustomQuizDetailsData, GetUserTrainingPlansData, ListPlanStatusData, GetResourceData, SearchData, SearchClickFeedbackData, SearchClickFeedbackError, GetTranslationsData, GetTranslationsError, GetTranslationsResponse, GetUsersForLocationsData, GetUsersData, GetOperatorsData, GetUserPreferencesData, SaveUserPreferencesData, SaveUserPreferencesError, SaveUserPreferencesResponse, GetUserPlanAssignmentSummariesData, UpdateChecklistData, UpdateChecklistError, ListAllChecklistsData, ListAssignableChecklistsData, ListAssignedByChecklistData, ListEditableChecklistsData, ResetChecklistData, ResetChecklistError, GetTemplatesData, CreatePlanFromTemplateData, CreatePlanFromTemplateError, CreatePlanFromTemplateResponse, DeleteChecklistData, DeleteChecklistError, GetChecklistData, DuplicateChecklistData, DuplicateChecklistError, DuplicateChecklistResponse2 as DuplicateChecklistResponse, UnassignUsersToChecklistData, UnassignUsersToChecklistError, AssignUsersToChecklistData, AssignUsersToChecklistError, SetDueDateOnChecklistData, SetDueDateOnChecklistError, UpdateChecklistStatusData, UpdateChecklistStatusError, StepHeartBeatData, StepHeartBeatError, UpdateStepStatus1Data, UpdateStepStatus1Error, WebhookQuizData, WebhookQuizError } from '../types.gen';
import { client } from '../client.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [
        params
    ];
};

export const getAuthQueryKey = (options?: Options<GetAuthData>) => createQueryKey('getAuth', options);

/**
 * Sets the authorization cookies and returns the users profile / feature set
 */
export const getAuthOptions = (options?: Options<GetAuthData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAuth({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAuthQueryKey(options)
    });
};

export const browseStructureQueryKey = (options?: Options<BrowseStructureData>) => createQueryKey('browseStructure', options);

/**
 * Get Browse structure
 * Returns complete browse structure by Country and Language
 */
export const browseStructureOptions = (options?: Options<BrowseStructureData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await browseStructure({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: browseStructureQueryKey(options)
    });
};

export const getCategoryQueryKey = (options: Options<GetCategoryData>) => createQueryKey('getCategory', options);

/**
 * Get Category
 */
export const getCategoryOptions = (options: Options<GetCategoryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCategory({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getCategoryQueryKey(options)
    });
};

/**
 * Streaming chat with the Pathway assistant
 * POST a Vercel AI SDK UI message list; receive a server-sent events stream of UI Message Stream events (token deltas, tool calls, tool outputs, etc.).
 */
export const chatMutation = (options?: Partial<Options<ChatData>>): UseMutationOptions<ChatResponse, ChatError, Options<ChatData>> => {
    const mutationOptions: UseMutationOptions<ChatResponse, ChatError, Options<ChatData>> = {
        mutationFn: async (fnOptions) => {
            await chat({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return {};
        }
    };
    return mutationOptions;
};

export const modelsQueryKey = (options?: Options<ModelsData>) => createQueryKey('models', options);

/**
 * List available chat model presets
 * Returns the Gemini model presets the chat endpoint accepts as modelKey.
 */
export const modelsOptions = (options?: Options<ModelsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await models({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: modelsQueryKey(options)
    });
};

export const listAssignedChecklistsQueryKey = (options?: Options<ListAssignedChecklistsData>) => createQueryKey('listAssignedChecklists', options);

/**
 * List assigned training checklists, should only pass V2
 * List assigned training checklists
 * @deprecated
 */
export const listAssignedChecklistsOptions = (options?: Options<ListAssignedChecklistsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listAssignedChecklists({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listAssignedChecklistsQueryKey(options)
    });
};

export const listChecklistTemplatesQueryKey = (options?: Options<ListChecklistTemplatesData>) => createQueryKey('listChecklistTemplates', options);

/**
 * List all training checklist templates
 * List all training checklist templates
 * @deprecated
 */
export const listChecklistTemplatesOptions = (options?: Options<ListChecklistTemplatesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listChecklistTemplates({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listChecklistTemplatesQueryKey(options)
    });
};

export const getConfigurationQueryKey = (options?: Options<GetConfigurationData>) => createQueryKey('getConfiguration', options);

/**
 * Returns the list of configured versions.
 * Returns the list of configured versions.
 */
export const getConfigurationOptions = (options?: Options<GetConfigurationData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getConfiguration({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getConfigurationQueryKey(options)
    });
};

export const getAllCoursesQueryKey = (options?: Options<GetAllCoursesData>) => createQueryKey('getAllCourses', options);

/**
 * List All Courses
 * List All Courses
 * @deprecated
 */
export const getAllCoursesOptions = (options?: Options<GetAllCoursesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAllCourses({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAllCoursesQueryKey(options)
    });
};

/**
 * Add a Course
 * @deprecated
 */
export const addCourseMutation = (options?: Partial<Options<AddCourseData>>): UseMutationOptions<AddCourseResponse, AddCourseError, Options<AddCourseData>> => {
    const mutationOptions: UseMutationOptions<AddCourseResponse, AddCourseError, Options<AddCourseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addCourse({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Assign one or more Team members to a Checklist
 * @deprecated
 */
export const assignUsersToChecklist1Mutation = (options?: Partial<Options<AssignUsersToChecklist1Data>>): UseMutationOptions<unknown, AssignUsersToChecklist1Error, Options<AssignUsersToChecklist1Data>> => {
    const mutationOptions: UseMutationOptions<unknown, AssignUsersToChecklist1Error, Options<AssignUsersToChecklist1Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await assignUsersToChecklist1({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listEnrollmentsByCourseQueryKey = (options: Options<ListEnrollmentsByCourseData>) => createQueryKey('listEnrollmentsByCourse', options);

/**
 * Status of all current enrollments to this course by optional location
 * @deprecated
 */
export const listEnrollmentsByCourseOptions = (options: Options<ListEnrollmentsByCourseData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listEnrollmentsByCourse({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listEnrollmentsByCourseQueryKey(options)
    });
};

export const getComplianceCoursesQueryKey = (options?: Options<GetComplianceCoursesData>) => createQueryKey('getComplianceCourses', options);

/**
 * Gets compliance courses based on country selected in user's profile
 * @deprecated
 */
export const getComplianceCoursesOptions = (options?: Options<GetComplianceCoursesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getComplianceCourses({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getComplianceCoursesQueryKey(options)
    });
};

export const generateCourseReportQueryKey = (options: Options<GenerateCourseReportData>) => createQueryKey('generateCourseReport', options);

/**
 * Sensitive data report on course by location
 * @deprecated
 */
export const generateCourseReportOptions = (options: Options<GenerateCourseReportData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await generateCourseReport({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: generateCourseReportQueryKey(options)
    });
};

export const getOperatorCourseSettingsQueryKey = (options: Options<GetOperatorCourseSettingsData>) => createQueryKey('getOperatorCourseSettings', options);

/**
 * Returns course settings for an operator
 * @deprecated
 */
export const getOperatorCourseSettingsOptions = (options: Options<GetOperatorCourseSettingsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOperatorCourseSettings({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOperatorCourseSettingsQueryKey(options)
    });
};

/**
 * Enables or Disables a course for an operator
 * @deprecated
 */
export const setOperatorCourseSettingMutation = (options?: Partial<Options<SetOperatorCourseSettingData>>): UseMutationOptions<unknown, SetOperatorCourseSettingError, Options<SetOperatorCourseSettingData>> => {
    const mutationOptions: UseMutationOptions<unknown, SetOperatorCourseSettingError, Options<SetOperatorCourseSettingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setOperatorCourseSetting({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getSqsslQueryKey = (options: Options<GetSqsslData>) => createQueryKey('getSqssl', options);

/**
 * Get SQSSO
 * @deprecated
 */
export const getSqsslOptions = (options: Options<GetSqsslData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getSqssl({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getSqsslQueryKey(options)
    });
};

/**
 * Synchronize User with LearnUpon
 * @deprecated
 */
export const synchronizeUserMutation = (options?: Partial<Options<SynchronizeUserData>>): UseMutationOptions<unknown, SynchronizeUserError, Options<SynchronizeUserData>> => {
    const mutationOptions: UseMutationOptions<unknown, SynchronizeUserError, Options<SynchronizeUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await synchronizeUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Handle LearnUpon webhook event
 * @deprecated
 */
export const learnUponWebhookMutation = (options?: Partial<Options<LearnUponWebhookData>>): UseMutationOptions<LearnUponWebhookResponse, LearnUponWebhookError, Options<LearnUponWebhookData>> => {
    const mutationOptions: UseMutationOptions<LearnUponWebhookResponse, LearnUponWebhookError, Options<LearnUponWebhookData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await learnUponWebhook({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Course by ID
 * @deprecated
 */
export const deleteCourseMutation = (options?: Partial<Options<DeleteCourseData>>): UseMutationOptions<unknown, DeleteCourseError, Options<DeleteCourseData>> => {
    const mutationOptions: UseMutationOptions<unknown, DeleteCourseError, Options<DeleteCourseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteCourse({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update a course
 * @deprecated
 */
export const updateCourseMutation = (options?: Partial<Options<UpdateCourseData>>): UseMutationOptions<UpdateCourseResponse, UpdateCourseError, Options<UpdateCourseData>> => {
    const mutationOptions: UseMutationOptions<UpdateCourseResponse, UpdateCourseError, Options<UpdateCourseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateCourse({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCourseByIdQueryKey = (options: Options<GetCourseByIdData>) => createQueryKey('getCourseById', options);

/**
 * Get Course by ID
 * @deprecated
 */
export const getCourseByIdOptions = (options: Options<GetCourseByIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCourseById({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getCourseByIdQueryKey(options)
    });
};

/**
 * Set course status by ID
 * @deprecated
 */
export const updateUserComplianceCourseDurationMutation = (options?: Partial<Options<UpdateUserComplianceCourseDurationData>>): UseMutationOptions<unknown, UpdateUserComplianceCourseDurationError, Options<UpdateUserComplianceCourseDurationData>> => {
    const mutationOptions: UseMutationOptions<unknown, UpdateUserComplianceCourseDurationError, Options<UpdateUserComplianceCourseDurationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateUserComplianceCourseDuration({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add or update documents
 */
export const saveDocumentsMutation = (options?: Partial<Options<SaveDocumentsData>>): UseMutationOptions<unknown, SaveDocumentsError, Options<SaveDocumentsData>> => {
    const mutationOptions: UseMutationOptions<unknown, SaveDocumentsError, Options<SaveDocumentsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await saveDocuments({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const setAuthCookieQueryKey = (options?: Options<SetAuthCookieData>) => createQueryKey('setAuthCookie', options);

/**
 * Sets auth cookie in response header
 */
export const setAuthCookieOptions = (options?: Options<SetAuthCookieData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await setAuthCookie({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: setAuthCookieQueryKey(options)
    });
};

/**
 * Delete document by ID
 */
export const deleteDocumentMutation = (options?: Partial<Options<DeleteDocumentData>>): UseMutationOptions<DeleteDocumentResponse, DeleteDocumentError, Options<DeleteDocumentData>> => {
    const mutationOptions: UseMutationOptions<DeleteDocumentResponse, DeleteDocumentError, Options<DeleteDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDocumentQueryKey = (options: Options<GetDocumentData>) => createQueryKey('getDocument', options);

/**
 * Get document by ID
 */
export const getDocumentOptions = (options: Options<GetDocumentData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getDocument({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getDocumentQueryKey(options)
    });
};

export const getCategoryIconsQueryKey = (options?: Options<GetCategoryIconsData>) => createQueryKey('getCategoryIcons', options);

/**
 * Get a list of all category icons
 */
export const getCategoryIconsOptions = (options?: Options<GetCategoryIconsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCategoryIcons({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getCategoryIconsQueryKey(options)
    });
};

export const getProcedureIconsQueryKey = (options?: Options<GetProcedureIconsData>) => createQueryKey('getProcedureIcons', options);

/**
 * Get a list of all procedure icons
 */
export const getProcedureIconsOptions = (options?: Options<GetProcedureIconsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getProcedureIcons({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getProcedureIconsQueryKey(options)
    });
};

export const getPlansSummaryQueryKey = (options?: Options<GetPlansSummaryData>) => createQueryKey('getPlansSummary', options);

/**
 * Get a report on all plans a user has build access to
 * Get a report on all plans a user has build access to, status default is ACTIVE
 */
export const getPlansSummaryOptions = (options?: Options<GetPlansSummaryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPlansSummary({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPlansSummaryQueryKey(options)
    });
};

export const getPlanReportQueryKey = (options: Options<GetPlanReportData>) => createQueryKey('getPlanReport', options);

/**
 * Get a report for all users on a specific plan
 * Get a report for all users on a specific plan
 */
export const getPlanReportOptions = (options: Options<GetPlanReportData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPlanReport({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPlanReportQueryKey(options)
    });
};

export const getUsersSummaryReportQueryKey = (options?: Options<GetUsersSummaryReportData>) => createQueryKey('getUsersSummaryReport', options);

/**
 * Get a report on all users plan progress for the passed in location numbers.
 * Returns summary of user's overall plan progress on all active plans at the passed in location numbers.
 */
export const getUsersSummaryReportOptions = (options?: Options<GetUsersSummaryReportData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getUsersSummaryReport({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getUsersSummaryReportQueryKey(options)
    });
};

export const getUserSummaryReportQueryKey = (options: Options<GetUserSummaryReportData>) => createQueryKey('getUserSummaryReport', options);

/**
 * Get a detailed plan summary report for a specific user
 * Get a detailed plan summary report for a specific user
 */
export const getUserSummaryReportOptions = (options: Options<GetUserSummaryReportData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getUserSummaryReport({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getUserSummaryReportQueryKey(options)
    });
};

export const getManagedPlansQueryKey = (options?: Options<GetManagedPlansData>) => createQueryKey('getManagedPlans', options);

/**
 * Get manage plans for user's owner ids
 * Get manage plans for logged in user's owner ids
 */
export const getManagedPlansOptions = (options?: Options<GetManagedPlansData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getManagedPlans({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getManagedPlansQueryKey(options)
    });
};

/**
 * Create a new plan.
 */
export const createPlanMutation = (options?: Partial<Options<CreatePlanData>>): UseMutationOptions<CreatePlanResponse, CreatePlanError, Options<CreatePlanData>> => {
    const mutationOptions: UseMutationOptions<CreatePlanResponse, CreatePlanError, Options<CreatePlanData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createPlan({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getActivePlanAssignmentsQueryKey = (options?: Options<GetActivePlanAssignmentsData>) => createQueryKey('getActivePlanAssignments', options);

/**
 * Get active assigned plans for user
 * Get active assigned plans for logged in user
 */
export const getActivePlanAssignmentsOptions = (options?: Options<GetActivePlanAssignmentsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getActivePlanAssignments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getActivePlanAssignmentsQueryKey(options)
    });
};

export const getSystemPlans1QueryKey = (options?: Options<GetSystemPlans1Data>) => createQueryKey('getSystemPlans1', options);

/**
 * Get system plans for user's business models
 * Get system plans for logged in user's business models
 */
export const getSystemPlans1Options = (options?: Options<GetSystemPlans1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getSystemPlans1({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getSystemPlans1QueryKey(options)
    });
};

export const getSystemPlansQueryKey = (options?: Options<GetSystemPlansData>) => createQueryKey('getSystemPlans', options);

/**
 * Get system plans for user's business models
 * Get system plans for logged in user's business models
 */
export const getSystemPlansOptions = (options?: Options<GetSystemPlansData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getSystemPlans({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getSystemPlansQueryKey(options)
    });
};

/**
 * Delete a plan.
 */
export const deletePlanMutation = (options?: Partial<Options<DeletePlanData>>): UseMutationOptions<DeletePlanResponse, DeletePlanError, Options<DeletePlanData>> => {
    const mutationOptions: UseMutationOptions<DeletePlanResponse, DeletePlanError, Options<DeletePlanData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deletePlan({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPlanAndAssignmentsQueryKey = (options: Options<GetPlanAndAssignmentsData>) => createQueryKey('getPlanAndAssignments', options);

/**
 * Get plan by id along with all of its active assignments
 * Get plan by id along with all of its active assignments
 */
export const getPlanAndAssignmentsOptions = (options: Options<GetPlanAndAssignmentsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPlanAndAssignments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPlanAndAssignmentsQueryKey(options)
    });
};

/**
 * Update a plan.
 */
export const updatePlanMutation = (options?: Partial<Options<UpdatePlanData>>): UseMutationOptions<UpdatePlanResponse, UpdatePlanError, Options<UpdatePlanData>> => {
    const mutationOptions: UseMutationOptions<UpdatePlanResponse, UpdatePlanError, Options<UpdatePlanData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updatePlan({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unassign users from plan.
 */
export const unassignUsersMutation = (options?: Partial<Options<UnassignUsersData>>): UseMutationOptions<UnassignUsersResponse, UnassignUsersError, Options<UnassignUsersData>> => {
    const mutationOptions: UseMutationOptions<UnassignUsersResponse, UnassignUsersError, Options<UnassignUsersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await unassignUsers({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Assign plan to users.
 */
export const assignUsersMutation = (options?: Partial<Options<AssignUsersData>>): UseMutationOptions<unknown, AssignUsersError, Options<AssignUsersData>> => {
    const mutationOptions: UseMutationOptions<unknown, AssignUsersError, Options<AssignUsersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await assignUsers({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Mark a plan as auto assignable.
 * Allows a user to mark a plan as auto assignable.
 */
export const patchAutoAssignMutation = (options?: Partial<Options<PatchAutoAssignData>>): UseMutationOptions<PatchAutoAssignResponse, PatchAutoAssignError, Options<PatchAutoAssignData>> => {
    const mutationOptions: UseMutationOptions<PatchAutoAssignResponse, PatchAutoAssignError, Options<PatchAutoAssignData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchAutoAssign({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Clone a plan.
 */
export const clonePlanMutation = (options?: Partial<Options<ClonePlanData>>): UseMutationOptions<ClonePlanResponse, ClonePlanError, Options<ClonePlanData>> => {
    const mutationOptions: UseMutationOptions<ClonePlanResponse, ClonePlanError, Options<ClonePlanData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await clonePlan({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Clone a plan as a system plan.
 */
export const cloneAsSystemPlanMutation = (options?: Partial<Options<CloneAsSystemPlanData>>): UseMutationOptions<CloneAsSystemPlanResponse, CloneAsSystemPlanError, Options<CloneAsSystemPlanData>> => {
    const mutationOptions: UseMutationOptions<CloneAsSystemPlanResponse, CloneAsSystemPlanError, Options<CloneAsSystemPlanData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await cloneAsSystemPlan({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update a users plan due date.
 * Changes when a user's plan is due by.
 */
export const updateDueDateMutation = (options?: Partial<Options<UpdateDueDateData>>): UseMutationOptions<UpdateDueDateResponse, UpdateDueDateError, Options<UpdateDueDateData>> => {
    const mutationOptions: UseMutationOptions<UpdateDueDateResponse, UpdateDueDateError, Options<UpdateDueDateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateDueDate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Mark plan as complete when all steps are complete.
 * Records when a user is complete with a plan.
 */
export const markPlanAsCompleteMutation = (options?: Partial<Options<MarkPlanAsCompleteData>>): UseMutationOptions<MarkPlanAsCompleteResponse, MarkPlanAsCompleteError, Options<MarkPlanAsCompleteData>> => {
    const mutationOptions: UseMutationOptions<MarkPlanAsCompleteResponse, MarkPlanAsCompleteError, Options<MarkPlanAsCompleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await markPlanAsComplete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Allow users to opt-in or out of readonly plans.
 * Subscribes a location/operator to a readonly plan.
 */
export const upsertReadonlySubscriptionMutation = (options?: Partial<Options<UpsertReadonlySubscriptionData>>): UseMutationOptions<UpsertReadonlySubscriptionResponse, UpsertReadonlySubscriptionError, Options<UpsertReadonlySubscriptionData>> => {
    const mutationOptions: UseMutationOptions<UpsertReadonlySubscriptionResponse, UpsertReadonlySubscriptionError, Options<UpsertReadonlySubscriptionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await upsertReadonlySubscription({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Resets all the steps in a plan.
 * Resets all the steps in a plan to incomplete.
 */
export const resetPlanStepsMutation = (options?: Partial<Options<ResetPlanStepsData>>): UseMutationOptions<ResetPlanStepsResponse, ResetPlanStepsError, Options<ResetPlanStepsData>> => {
    const mutationOptions: UseMutationOptions<ResetPlanStepsResponse, ResetPlanStepsError, Options<ResetPlanStepsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resetPlanSteps({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update duration for logged in user's plan and step.
 * Records how long a user takes on a given plan and step.
 */
export const heartbeatMutation = (options?: Partial<Options<HeartbeatData>>): UseMutationOptions<HeartbeatResponse, HeartbeatError, Options<HeartbeatData>> => {
    const mutationOptions: UseMutationOptions<HeartbeatResponse, HeartbeatError, Options<HeartbeatData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await heartbeat({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Updates a step status to complete.
 * Updates a single step status to complete.
 */
export const updateStepStatusMutation = (options?: Partial<Options<UpdateStepStatusData>>): UseMutationOptions<UpdateStepStatusResponse, UpdateStepStatusError, Options<UpdateStepStatusData>> => {
    const mutationOptions: UseMutationOptions<UpdateStepStatusResponse, UpdateStepStatusError, Options<UpdateStepStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateStepStatus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update duration for passed in user's plan and step in train together.
 * Records how long the passed in users take on the given plan and step in train together.
 */
export const heartbeatTrainTogetherMutation = (options?: Partial<Options<HeartbeatTrainTogetherData>>): UseMutationOptions<HeartbeatTrainTogetherResponse, HeartbeatTrainTogetherError, Options<HeartbeatTrainTogetherData>> => {
    const mutationOptions: UseMutationOptions<HeartbeatTrainTogetherResponse, HeartbeatTrainTogetherError, Options<HeartbeatTrainTogetherData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await heartbeatTrainTogether({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Mark the passed in plan's step status for the user ids in training mode.
 */
export const trainTogetherUpdateStepStatusMutation = (options?: Partial<Options<TrainTogetherUpdateStepStatusData>>): UseMutationOptions<TrainTogetherUpdateStepStatusResponse, TrainTogetherUpdateStepStatusError, Options<TrainTogetherUpdateStepStatusData>> => {
    const mutationOptions: UseMutationOptions<TrainTogetherUpdateStepStatusResponse, TrainTogetherUpdateStepStatusError, Options<TrainTogetherUpdateStepStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await trainTogetherUpdateStepStatus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Mark plan as complete for the passed user ids in training together.
 * Records when a user is complete with a plan in training together.
 */
export const trainTogetherMarkPlanAsCompleteMutation = (options?: Partial<Options<TrainTogetherMarkPlanAsCompleteData>>): UseMutationOptions<TrainTogetherMarkPlanAsCompleteResponse, TrainTogetherMarkPlanAsCompleteError, Options<TrainTogetherMarkPlanAsCompleteData>> => {
    const mutationOptions: UseMutationOptions<TrainTogetherMarkPlanAsCompleteResponse, TrainTogetherMarkPlanAsCompleteError, Options<TrainTogetherMarkPlanAsCompleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await trainTogetherMarkPlanAsComplete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCustomQuizzesQueryKey = (options?: Options<GetCustomQuizzesData>) => createQueryKey('getCustomQuizzes', options);

/**
 * Gets a list of custom quizzes
 * Gets a list of custom quizzes
 */
export const getCustomQuizzesOptions = (options?: Options<GetCustomQuizzesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCustomQuizzes({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getCustomQuizzesQueryKey(options)
    });
};

/**
 * Create a custom quiz
 */
export const createCustomQuizMutation = (options?: Partial<Options<CreateCustomQuizData>>): UseMutationOptions<CreateCustomQuizResponse, CreateCustomQuizError, Options<CreateCustomQuizData>> => {
    const mutationOptions: UseMutationOptions<CreateCustomQuizResponse, CreateCustomQuizError, Options<CreateCustomQuizData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createCustomQuiz({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Edit a custom quiz
 */
export const updateCustomQuizMutation = (options?: Partial<Options<UpdateCustomQuizData>>): UseMutationOptions<UpdateCustomQuizResponse, UpdateCustomQuizError, Options<UpdateCustomQuizData>> => {
    const mutationOptions: UseMutationOptions<UpdateCustomQuizResponse, UpdateCustomQuizError, Options<UpdateCustomQuizData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateCustomQuiz({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete custom quiz
 */
export const deleteCustomQuizMutation = (options?: Partial<Options<DeleteCustomQuizData>>): UseMutationOptions<unknown, DeleteCustomQuizError, Options<DeleteCustomQuizData>> => {
    const mutationOptions: UseMutationOptions<unknown, DeleteCustomQuizError, Options<DeleteCustomQuizData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteCustomQuiz({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCustomQuizDetailsQueryKey = (options: Options<GetCustomQuizDetailsData>) => createQueryKey('getCustomQuizDetails', options);

/**
 * Get custom quiz details
 */
export const getCustomQuizDetailsOptions = (options: Options<GetCustomQuizDetailsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCustomQuizDetails({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getCustomQuizDetailsQueryKey(options)
    });
};

export const getUserTrainingPlansQueryKey = (options: Options<GetUserTrainingPlansData>) => createQueryKey('getUserTrainingPlans', options);

/**
 * Get user's training plans by userId
 * @deprecated
 */
export const getUserTrainingPlansOptions = (options: Options<GetUserTrainingPlansData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getUserTrainingPlans({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getUserTrainingPlansQueryKey(options)
    });
};

export const listPlanStatusQueryKey = (options?: Options<ListPlanStatusData>) => createQueryKey('listPlanStatus', options);

/**
 * Get training plan statuses by location
 * Get training plan statuses by location
 * @deprecated
 */
export const listPlanStatusOptions = (options?: Options<ListPlanStatusData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listPlanStatus({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listPlanStatusQueryKey(options)
    });
};

export const getResourceQueryKey = (options: Options<GetResourceData>) => createQueryKey('getResource', options);

/**
 * Get a resource
 * Returns complete resource structure by id
 */
export const getResourceOptions = (options: Options<GetResourceData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getResource({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getResourceQueryKey(options)
    });
};

export const searchQueryKey = (options: Options<SearchData>) => createQueryKey('search', options);

/**
 * Search for results
 * Searches for resources by query, country and language. Returns document results along with optional GenAI smart answers. Smart answers include source attribution with document titles, URLs, text excerpts, and confidence scores.
 */
export const searchOptions = (options: Options<SearchData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await search({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: searchQueryKey(options)
    });
};

/**
 * Submit click feedback for a result
 * Improves search results by submitting click feedback for a specific result and query.
 */
export const searchClickFeedbackMutation = (options?: Partial<Options<SearchClickFeedbackData>>): UseMutationOptions<unknown, SearchClickFeedbackError, Options<SearchClickFeedbackData>> => {
    const mutationOptions: UseMutationOptions<unknown, SearchClickFeedbackError, Options<SearchClickFeedbackData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await searchClickFeedback({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get Natural Language Translations
 * Facilitates translation from one natural language to another.
 */
export const getTranslationsMutation = (options?: Partial<Options<GetTranslationsData>>): UseMutationOptions<GetTranslationsResponse, GetTranslationsError, Options<GetTranslationsData>> => {
    const mutationOptions: UseMutationOptions<GetTranslationsResponse, GetTranslationsError, Options<GetTranslationsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await getTranslations({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getUsersForLocationsQueryKey = (options?: Options<GetUsersForLocationsData>) => createQueryKey('getUsersForLocations', options);

/**
 * Find users assigned to locations
 * Find users assigned to locations.
 */
export const getUsersForLocationsOptions = (options?: Options<GetUsersForLocationsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getUsersForLocations({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getUsersForLocationsQueryKey(options)
    });
};

export const getUsersQueryKey = (options?: Options<GetUsersData>) => createQueryKey('getUsers', options);

/**
 * Get users by locations
 * @deprecated
 */
export const getUsersOptions = (options?: Options<GetUsersData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getUsers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getUsersQueryKey(options)
    });
};

export const getOperatorsQueryKey = (options?: Options<GetOperatorsData>) => createQueryKey('getOperators', options);

/**
 * Get operators and locations
 */
export const getOperatorsOptions = (options?: Options<GetOperatorsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOperators({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOperatorsQueryKey(options)
    });
};

export const getUserPreferencesQueryKey = (options?: Options<GetUserPreferencesData>) => createQueryKey('getUserPreferences', options);

/**
 * Retrieve user preferences
 */
export const getUserPreferencesOptions = (options?: Options<GetUserPreferencesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getUserPreferences({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getUserPreferencesQueryKey(options)
    });
};

/**
 * Save user preferences
 */
export const saveUserPreferencesMutation = (options?: Partial<Options<SaveUserPreferencesData>>): UseMutationOptions<SaveUserPreferencesResponse, SaveUserPreferencesError, Options<SaveUserPreferencesData>> => {
    const mutationOptions: UseMutationOptions<SaveUserPreferencesResponse, SaveUserPreferencesError, Options<SaveUserPreferencesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await saveUserPreferences({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getUserPlanAssignmentSummariesQueryKey = (options: Options<GetUserPlanAssignmentSummariesData>) => createQueryKey('getUserPlanAssignmentSummaries', options);

/**
 * Get User Plan Assignment Summaries
 * Returns a summary of the user's plan assignments.
 */
export const getUserPlanAssignmentSummariesOptions = (options: Options<GetUserPlanAssignmentSummariesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getUserPlanAssignmentSummaries({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getUserPlanAssignmentSummariesQueryKey(options)
    });
};

/**
 * Update a checklist
 * Update a checklist
 * @deprecated
 */
export const updateChecklistMutation = (options?: Partial<Options<UpdateChecklistData>>): UseMutationOptions<unknown, UpdateChecklistError, Options<UpdateChecklistData>> => {
    const mutationOptions: UseMutationOptions<unknown, UpdateChecklistError, Options<UpdateChecklistData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateChecklist({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listAllChecklistsQueryKey = (options?: Options<ListAllChecklistsData>) => createQueryKey('listAllChecklists', options);

/**
 * List all training checklists
 * List all training checklists
 * @deprecated
 */
export const listAllChecklistsOptions = (options?: Options<ListAllChecklistsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listAllChecklists({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listAllChecklistsQueryKey(options)
    });
};

export const listAssignableChecklistsQueryKey = (options?: Options<ListAssignableChecklistsData>) => createQueryKey('listAssignableChecklists', options);

/**
 * List all training checklists the active user can assign with their assigned counts
 * List all training checklists the active user can assign with their assigned counts
 * @deprecated
 */
export const listAssignableChecklistsOptions = (options?: Options<ListAssignableChecklistsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listAssignableChecklists({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listAssignableChecklistsQueryKey(options)
    });
};

export const listAssignedByChecklistQueryKey = (options: Options<ListAssignedByChecklistData>) => createQueryKey('listAssignedByChecklist', options);

/**
 * Status of all assigned users to this training checklist
 * Status of all assigned users to this training checklist
 * @deprecated
 */
export const listAssignedByChecklistOptions = (options: Options<ListAssignedByChecklistData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listAssignedByChecklist({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listAssignedByChecklistQueryKey(options)
    });
};

export const listEditableChecklistsQueryKey = (options?: Options<ListEditableChecklistsData>) => createQueryKey('listEditableChecklists', options);

/**
 * List all training checklists the active user can edit/modify
 * List all training checklists the active user can edit/modify
 * @deprecated
 */
export const listEditableChecklistsOptions = (options?: Options<ListEditableChecklistsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listEditableChecklists({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listEditableChecklistsQueryKey(options)
    });
};

/**
 * Reset current state of checklist for users
 * Reset current state of checklist for users
 * @deprecated
 */
export const resetChecklistMutation = (options?: Partial<Options<ResetChecklistData>>): UseMutationOptions<unknown, ResetChecklistError, Options<ResetChecklistData>> => {
    const mutationOptions: UseMutationOptions<unknown, ResetChecklistError, Options<ResetChecklistData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resetChecklist({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTemplatesQueryKey = (options?: Options<GetTemplatesData>) => createQueryKey('getTemplates', options);

/**
 * Get all plan templates
 *    The type of templates returned depend on the audience. Licensee users will only see `LICENSEE` templates
 * and all other users will see `FRANCHISEE` templates (this includes operator consultants and brand
 * champions).
 *
 * @deprecated
 */
export const getTemplatesOptions = (options?: Options<GetTemplatesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getTemplates({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getTemplatesQueryKey(options)
    });
};

/**
 * Create a plan from a template
 * Create a plan from a template
 * @deprecated
 */
export const createPlanFromTemplateMutation = (options?: Partial<Options<CreatePlanFromTemplateData>>): UseMutationOptions<CreatePlanFromTemplateResponse, CreatePlanFromTemplateError, Options<CreatePlanFromTemplateData>> => {
    const mutationOptions: UseMutationOptions<CreatePlanFromTemplateResponse, CreatePlanFromTemplateError, Options<CreatePlanFromTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createPlanFromTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a checklist
 * Delete a checklist
 * @deprecated
 */
export const deleteChecklistMutation = (options?: Partial<Options<DeleteChecklistData>>): UseMutationOptions<unknown, DeleteChecklistError, Options<DeleteChecklistData>> => {
    const mutationOptions: UseMutationOptions<unknown, DeleteChecklistError, Options<DeleteChecklistData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteChecklist({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getChecklistQueryKey = (options: Options<GetChecklistData>) => createQueryKey('getChecklist', options);

/**
 * Get checklist by id
 * Get checklist by id
 * @deprecated
 */
export const getChecklistOptions = (options: Options<GetChecklistData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getChecklist({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getChecklistQueryKey(options)
    });
};

/**
 * Duplicate a checklist
 * Duplicate a checklist
 * @deprecated
 */
export const duplicateChecklistMutation = (options?: Partial<Options<DuplicateChecklistData>>): UseMutationOptions<DuplicateChecklistResponse, DuplicateChecklistError, Options<DuplicateChecklistData>> => {
    const mutationOptions: UseMutationOptions<DuplicateChecklistResponse, DuplicateChecklistError, Options<DuplicateChecklistData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await duplicateChecklist({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unassign one or more team members to a checklist
 * Unassign one or more team members to a checklist
 * @deprecated
 */
export const unassignUsersToChecklistMutation = (options?: Partial<Options<UnassignUsersToChecklistData>>): UseMutationOptions<unknown, UnassignUsersToChecklistError, Options<UnassignUsersToChecklistData>> => {
    const mutationOptions: UseMutationOptions<unknown, UnassignUsersToChecklistError, Options<UnassignUsersToChecklistData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await unassignUsersToChecklist({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Assign one or more team members to a checklist
 * Assign one or more team members to a checklist
 * @deprecated
 */
export const assignUsersToChecklistMutation = (options?: Partial<Options<AssignUsersToChecklistData>>): UseMutationOptions<unknown, AssignUsersToChecklistError, Options<AssignUsersToChecklistData>> => {
    const mutationOptions: UseMutationOptions<unknown, AssignUsersToChecklistError, Options<AssignUsersToChecklistData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await assignUsersToChecklist({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set due date on one or more team members assigned to a checklist
 * Set due date on one or more team members assigned to a checklist
 * @deprecated
 */
export const setDueDateOnChecklistMutation = (options?: Partial<Options<SetDueDateOnChecklistData>>): UseMutationOptions<unknown, SetDueDateOnChecklistError, Options<SetDueDateOnChecklistData>> => {
    const mutationOptions: UseMutationOptions<unknown, SetDueDateOnChecklistError, Options<SetDueDateOnChecklistData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setDueDateOnChecklist({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update checklist status
 * Update checklist status
 * @deprecated
 */
export const updateChecklistStatusMutation = (options?: Partial<Options<UpdateChecklistStatusData>>): UseMutationOptions<unknown, UpdateChecklistStatusError, Options<UpdateChecklistStatusData>> => {
    const mutationOptions: UseMutationOptions<unknown, UpdateChecklistStatusError, Options<UpdateChecklistStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateChecklistStatus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Increment the time a user or trainer has spent on a checklist step via heartbeat mechanism
 * Increment the time a user or trainer has spent on a checklist step via heartbeat mechanism
 * @deprecated
 */
export const stepHeartBeatMutation = (options?: Partial<Options<StepHeartBeatData>>): UseMutationOptions<unknown, StepHeartBeatError, Options<StepHeartBeatData>> => {
    const mutationOptions: UseMutationOptions<unknown, StepHeartBeatError, Options<StepHeartBeatData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await stepHeartBeat({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update a checklist step status for a user or trainer
 * Update a checklist step status for a user or trainer
 * @deprecated
 */
export const updateStepStatus1Mutation = (options?: Partial<Options<UpdateStepStatus1Data>>): UseMutationOptions<unknown, UpdateStepStatus1Error, Options<UpdateStepStatus1Data>> => {
    const mutationOptions: UseMutationOptions<unknown, UpdateStepStatus1Error, Options<UpdateStepStatus1Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateStepStatus1({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Store quiz results for plan from Typeform
 */
export const webhookQuizMutation = (options?: Partial<Options<WebhookQuizData>>): UseMutationOptions<unknown, WebhookQuizError, Options<WebhookQuizData>> => {
    const mutationOptions: UseMutationOptions<unknown, WebhookQuizError, Options<WebhookQuizData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await webhookQuiz({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
